export default{
    estados: [],
}